export default{
    estados: [],
}